import { render, staticRenderFns } from "./card-client-profile.vue?vue&type=template&id=06678055&"
import script from "./card-client-profile.vue?vue&type=script&lang=js&"
export * from "./card-client-profile.vue?vue&type=script&lang=js&"
import style0 from "./card-client-profile.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports